import React, {useState} from 'react'
import {nineToKnowTemplatesList} from '../Constants';
import TemplateOne from './TemplateOne';
import TemplateTwo from './TemplateTwo';
import TemplateThree from './TemplateThree';
import {useTemplates} from "./useTemplates";
import CustomizeTempModal from "./CustomizeTempModal";
import {TemplateZero} from "./TemplateZero";
import {PromptDialog} from "../Dialog/Message";

const TemplateMain = ({props, buttonComp}) => {
  const [customMessage, setCustomMessage] = useState({messageTitle: '', messageBody: ''});
  const [showMessage, setShowMessage] = useState(false);
  const {
    displayEditContentButton,
    canCustomize,
    activeTemplate,
    setTemplateAsActive,
    modalShow,
    toggleModal,
    content,
    image1,
    image2,
    customizeTextHandler,
    fileSelectedHandler1,
    fileSelectedHandler2,
    setSelectedFile1,
    setSelectedFile2,
    preview1,
    preview2,
    applyTemplateCustomizations,
    savingTemplate,
    resetTemplateHandler,
    publishActiveTemplate,
    lastPublishedAt,
    nineToKnowActiveTemplate
  } = useTemplates({
    ...props, customMessage,
    setCustomMessage,
    showMessage,
    setShowMessage
  })
  const getTemplateLastPublishString = () => {
    if (lastPublishedAt && typeof lastPublishedAt === 'object' && lastPublishedAt[nineToKnowActiveTemplate]) {
      return `Template ${parseInt(nineToKnowActiveTemplate) + 1} published ${lastPublishedAt[nineToKnowActiveTemplate]}`;
    }
    return '';
  }
  const getActiveTemplate = () => {
    switch (activeTemplate) {
      case '1':
        return <TemplateOne toggleModal={toggleModal}
                            content={content}
                            image1={image1}
                            image2={image2}
                            buttonComp={buttonComp}
                            displayEditContentButton={displayEditContentButton}
                            activeTemplate={activeTemplate}
                            publishActiveTemplate={publishActiveTemplate}
                            canCustomize={canCustomize}
                            lastPublishedAt={lastPublishedAt}
        />
      case "2":
        return <TemplateTwo toggleModal={toggleModal}
                            content={content}
                            image1={image1}
                            image2={image2}
                            buttonComp={buttonComp}
                            displayEditContentButton={displayEditContentButton}
                            activeTemplate={activeTemplate}
                            publishActiveTemplate={publishActiveTemplate}
                            canCustomize={canCustomize}
                            lastPublishedAt={lastPublishedAt}
        />
      case "3":
        return <TemplateThree toggleModal={toggleModal}
                              content={content}
                              image1={image1}
                              buttonComp={buttonComp}
                              displayEditContentButton={displayEditContentButton}
                              activeTemplate={activeTemplate}
                              publishActiveTemplate={publishActiveTemplate}
                              canCustomize={canCustomize}
                              lastPublishedAt={lastPublishedAt}
        />
      default:
        return <TemplateZero toggleModal={toggleModal}
                             content={content}
                             image1={image1}
                             buttonComp={buttonComp}
                             displayEditContentButton={displayEditContentButton}
                             activeTemplate={activeTemplate}
                             resetTemplateHandler={resetTemplateHandler}
                             publishActiveTemplate={publishActiveTemplate}
                             canCustomize={canCustomize}
        />
    }
  }
  return (
    <div className='home_92k'>
      <div className="temp_list">
        {canCustomize && nineToKnowTemplatesList.map(template => {
          return (
            <button
              key={template.id}
              onClick={() => {
                setTemplateAsActive(template.id)
              }}
              type="button"
              value={template.id}
              className={`${activeTemplate === template.id ? 'active' : ''}`}
            >
              {template.title}
            </button>
          );
        })}
        {
          canCustomize &&
          <>
            <br/>
            <div style={{'fontStyle': 'italic', 'fontSize': 'small', 'color': '#777', 'marginTop':'10px','marginBottom':'-15px'}}>
            {getTemplateLastPublishString()}
              </div>
          </>
        }
      </div>
      {displayEditContentButton &&
        <CustomizeTempModal modalShow={modalShow}
                            setModalShow={toggleModal}
                            content={content}
                            image1={image1}
                            image2={image2}
                            activeTemplate={activeTemplate}
                            customizeTextHandler={customizeTextHandler}
                            fileSelectedHandler1={fileSelectedHandler1}
                            fileSelectedHandler2={fileSelectedHandler2}
                            setSelectedFile1={setSelectedFile1}
                            setSelectedFile2={setSelectedFile2}
                            preview1={preview1}
                            preview2={preview2}
                            applyTemplateCustomizations={applyTemplateCustomizations}
                            savingTemplate={savingTemplate}
                            resetTemplateHandler={resetTemplateHandler}
        />
      }
      {getActiveTemplate()}
      {
        showMessage &&
        <PromptDialog
          onRef={(ref) => {
          }}
          onlyDialog={true}
          messageTitle={customMessage.messageTitle}
          messageBody={customMessage.messageBody}
          okText={"Ok"}
          cancelText={"No"}
          onOk={() => setShowMessage(false)}
          onCancel={() => setShowMessage(false)}
          showMessage={showMessage}
        />
      }
    </div>
  )
}

export default TemplateMain
